export default "__VITE_ASSET__BQZKqL_A__"